var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRatingFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 15C35.1475 15 15 35.1475 15 60C15 84.8525 35.1475 105 60 105C84.8525 105 105 84.8525 105 60C105 35.1475 84.8525 15 60 15ZM76.8 82.86L60 71.1L43.2 82.86L51.6 64.38L34.8 52.6175H53.28L59.9975 34.1375L66.72 52.6175H85.2L68.4 64.3775L76.8 82.8575V82.86Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingFilled);
export default __webpack_public_path__ + "static/media/Rating_filled.d6f21ce8.svg";
export { ForwardRef as ReactComponent };